if (!customElements.get('compare-donors')) {
  customElements.define('compare-donors', class CompareDonors extends BaseElement {
    constructor(props) {
      super(props);
      this.donors = [null, null];
      this.allDonors = [];
    }

    init() {
      this.loadDonorsFromData();
      this.fillFromUrl();
      this.initEvents();
      this.initDonorSelects();
      this.initAddTraitButtons();
      this.update();
      this.syncTraitsHeight();

      window.addEventListener('resize', () => this.syncTraitsHeight());
    }

    syncTraitsHeight() {
      const traitsColumn = this.querySelector('.compare-donors__results-traits');
      const donorCard = this.querySelector('.compare-donors__donor-card');
      const donorValues = this.querySelector('.compare-donors__donor-values');

      if (!traitsColumn || !donorCard || !donorValues) return;

      const cardRect = donorCard.getBoundingClientRect();
      const valuesRect = donorValues.getBoundingClientRect();
      const paddingTop = valuesRect.top - cardRect.top;

      traitsColumn.style.paddingTop = `${paddingTop}px`;
    }

    loadDonorsFromData() {
      try {
        const data = this.querySelector('[data-donors]').innerText;

        if (data) {
          this.allDonors = JSON.parse(data) || [];
        }
      } catch (e) {
        console.error('Failed to parse donors data', e);
      }
    }

    fillFromUrl() {
      const params = new URLSearchParams(window.location.search);

      params.forEach((value, name) => {
        const option = this.querySelector(`.compare-donors__traits option[value="${name}"]`);
        const checkbox = this.querySelector(`.compare-donors__traits-mobile [name="${name}"]`);

        if (option) {
          option.selected = true;
          option.closest('select').dispatchEvent(new Event('change'));
        }

        if (checkbox) {
          checkbox.checked = true;
          checkbox.dispatchEvent(new Event('change'));
        }
      });

      const donor1 = params.get('donor1');
      const donor2 = params.get('donor2');

      if (donor1) {
        this.selectDonorByHandle(donor1, 0);
      }

      if (donor2) {
        this.selectDonorByHandle(donor2, 1);
      }
    }

    selectDonorByHandle(handle, index) {
      const donor = this.allDonors.find(d => d.handle === handle);
      const selectEl = this.querySelector(`custom-select-donor[data-donor-index="${index + 1}"] select`);
      if (donor && selectEl) {
        selectEl.value = handle;
        this.donors[index] = donor;
        this.renderDonor(index);
        this.renderComparison();
      }
    }

    initEvents() {
      this.querySelectorAll('.compare-donors__traits select').forEach(select => {
        select.addEventListener('change', e => {
          const url = new URL(window.location);

          select.querySelectorAll('option').forEach(option => {
            const checkbox = this.querySelector(`.compare-donors__traits-mobile [name="${option.value}"]`);

            if (option.selected) {
              url.searchParams.set(option.value, '1');
              if (checkbox) checkbox.checked = true;
            } else {
              url.searchParams.delete(option.value);
              if (checkbox) checkbox.checked = false;
            }
          });

          window.history.replaceState({}, '', url);
          this.update();
        });
      });

      this.querySelectorAll('.compare-donors__traits-mobile input').forEach(checkbox => {
        checkbox.addEventListener('change', e => {
          const url = new URL(window.location);
          const option = this.querySelector(`.compare-donors__traits option[value="${checkbox.name}"]`);

          if (checkbox.checked) {
            url.searchParams.set(checkbox.name, '1');
            if (option) option.selected = true;
          } else {
            url.searchParams.delete(checkbox.name);
            if (option) option.selected = false;
          }

          if (option) {
            option.closest('select').dispatchEvent(new Event('change'));
          }

          window.history.replaceState({}, '', url);
          this.update();
        });
      });

      // Navigation buttons
      this.querySelectorAll('.compare-donors__donor-nav-btn').forEach(btn => {
        btn.addEventListener('click', e => {
          const donorCard = btn.closest('.compare-donors__donor');
          const index = parseInt(donorCard.dataset.donorIndex) - 1;
          const direction = btn.dataset.direction;
          this.navigateDonor(index, direction);
        });
      });
    }

    initDonorSelects() {
      this.querySelectorAll('custom-select-donor').forEach(customSelect => {
        const index = parseInt(customSelect.dataset.donorIndex) - 1;

        customSelect.addEventListener('change', () => {
          const handle = customSelect.querySelector('select').value;
          if (handle) {
            const donor = this.allDonors.find(d => d.handle === handle);
            if (donor) {
              this.donors[index] = donor;
              this.updateUrl();
              this.renderDonor(index);
              this.renderComparison();
            }
          } else {
            this.donors[index] = null;
            this.updateUrl();
            this.renderDonor(index);
            this.renderComparison();
          }
        });
      });
    }

    updateUrl() {
      const url = new URL(window.location);
      this.donors.forEach((donor, i) => {
        if (donor) {
          url.searchParams.set(`donor${i + 1}`, donor.handle);
        } else {
          url.searchParams.delete(`donor${i + 1}`);
        }
      });
      window.history.replaceState({}, '', url);
    }

    renderDonor(index) {
      const donor = this.donors[index];
      const card = this.querySelector(`.compare-donors__donor[data-donor-index="${index + 1}"]`);
      if (!card) return;

      const innerCard = card.querySelector('.compare-donors__donor-card');
      const actionsCard = this.querySelector(`.compare-donors__results-table-action[data-donor-index="${index + 1}"]`);
      const photo = card.querySelector('.compare-donors__donor-image-photo');
      const placeholder = card.querySelector('.compare-donors__donor-image-placeholder');
      const link = card.querySelector('.compare-donors__donor-link');
      const prevBtn = card.querySelector('.compare-donors__donor-prev');
      const nextBtn = card.querySelector('.compare-donors__donor-next');

      if (donor) {
        if (donor.image) {
          photo.src = donor.image;
          photo.alt = donor.title;
          photo.style.display = 'block';
          placeholder.style.display = 'none';
          photo.onload = () => this.syncTraitsHeight();
        }
        link.href = donor.url;
        link.style.display = '';
        actionsCard.querySelector('.compare-donors__donor-link').href = donor.url;

        const donorIndex = this.allDonors.findIndex(d => d.id === donor.id);
        prevBtn.disabled = donorIndex <= 0;
        nextBtn.disabled = donorIndex >= this.allDonors.length - 1;

        innerCard.dataset.productId = donor.id;
        actionsCard.dataset.productId = donor.id;
      } else {
        photo.style.display = 'none';
        placeholder.style.display = '';
        link.href = '#';
        link.style.display = 'none';
        actionsCard.querySelector('.compare-donors__donor-link').href = '#';
        prevBtn.disabled = true;
        nextBtn.disabled = true;

        innerCard.dataset.productId = undefined;
        actionsCard.dataset.productId = undefined;
      }

      innerCard.querySelector('product-favourite')?.update();
      innerCard.querySelector('product-visibility')?.update();
      innerCard.querySelector('product-note-button')?.update();

      actionsCard.querySelector('product-favourite')?.update();
      actionsCard.querySelector('product-visibility')?.update();
      actionsCard.querySelector('product-note-button')?.update();

      this.syncTraitsHeight();
    }

    navigateDonor(index, direction) {
      const currentDonor = this.donors[index];
      if (!currentDonor) return;

      const currentIndex = this.allDonors.findIndex(d => d.id === currentDonor.id);
      const newIndex = direction === 'prev' ? currentIndex - 1 : currentIndex + 1;

      if (newIndex >= 0 && newIndex < this.allDonors.length) {
        const newDonor = this.allDonors[newIndex];

        if (this.donors.some(d => d && d.id === newDonor.id)) {
          return;
        }

        this.donors[index] = newDonor;

        const selectEl = this.querySelector(`custom-select-donor[data-donor-index="${index + 1}"] select`);

        if (selectEl) {
          selectEl.value = newDonor.handle;
          selectEl.dispatchEvent(new Event('change'));
        }

        this.updateUrl();
        this.renderDonor(index);
        this.renderComparison();
      }
    }

    initAddTraitButtons() {
      this.querySelectorAll('.compare-donors__add-trait, .compare-donors__traits--button button').forEach(btn => {
        btn.addEventListener('click', () => {
          const popup = this.querySelector('.compare-donors__traits-popup');
          if (popup) popup.open();
        });
      });
    }

    getSelectedTraits() {
      const traits = [];
      this.querySelectorAll('.compare-donors__traits select').forEach(select => {
        select.querySelectorAll('option:checked').forEach(option => {
          if (!option.dataset.optionPlaceholder) {
            traits.push({
              key: option.value,
              label: option.text
            });
          }
        });
      });
      return traits;
    }

    getTraitValue(donor, traitKey) {
      if (!donor) {
        return '-';
      }

      if (traitKey.startsWith('straw_')) {
        const handle = traitKey.replace('straw_', '');
        let result = '-';

        donor.straws.forEach(straw => {
          if (straw.handle === handle) {
            if (straw.available) {
              result = straw.price_formatted;
            } else {
              result = window.compareDonorsStrings.soldOut;
            }
          }
        });

        return result;
      }

      if (donor.metafields && donor.metafields[traitKey]) {
        return donor.metafields[traitKey];
      }

      return '-';
    }

    renderComparison() {
      const traits = this.getSelectedTraits();

      const traitsList = this.querySelector('.compare-donors__results-traits-list');
      if (traitsList) {
        traitsList.innerHTML = traits.map(trait => `
          <div class="compare-donors__results-trait" data-trait="${trait.key}">
            <span>${trait.label}</span>
            <button type="button" class="compare-donors__results-trait-remove" data-trait="${trait.key}">
              <svg xmlns="http://www.w3.org/2000/svg" width="13" height="1" viewBox="0 0 13 1" fill="none">
                <path d="M0.5 0.5H11.5833" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>
          </div>
        `).join('');

        traitsList.querySelectorAll('.compare-donors__results-trait-remove').forEach(btn => {
          btn.addEventListener('click', () => {
            this.removeTrait(btn.dataset.trait);
          });
        });
      }

      this.donors.forEach((donor, index) => {
        const valuesContainer = this.querySelector(`.compare-donors__donor[data-donor-index="${index + 1}"] .compare-donors__donor-values`);
        if (valuesContainer) {
          valuesContainer.innerHTML = traits.map(trait => {
            const value = this.getTraitValue(donor, trait.key);
            return `<div class="compare-donors__donor-value${value === '-' ? ' is-empty' : ''}">${value}</div>`;
          }).join('');
        }
      });

      const tableBody = this.querySelector('.compare-donors__results-table-body');
      if (tableBody) {
        tableBody.innerHTML = traits.map(trait => `
          <div class="compare-donors__results-table-row">
            <div class="compare-donors__results-table-header">
              <span>${trait.label}</span>
              <button type="button" class="compare-donors__results-trait-remove" data-trait="${trait.key}">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 2" fill="none">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M.5 1C.5.7.7.5 1 .5h8a.5.5 0 110 1H1A.5.5 0 01.5 1z" fill="currentColor"/>
                </svg>
              </button>
            </div>
            <div class="compare-donors__results-table-values">
              ${this.donors.map(donor => {
                const value = this.getTraitValue(donor, trait.key);
                return `<div class="compare-donors__results-table-value${value === '-' ? ' is-empty' : ''}">${value}</div>`;
              }).join('')}
            </div>
          </div>
        `).join('');

        tableBody.querySelectorAll('.compare-donors__results-trait-remove').forEach(btn => {
          btn.addEventListener('click', () => {
            this.removeTrait(btn.dataset.trait);
          });
        });
      }
    }

    removeTrait(traitKey) {
      const option = this.querySelector(`.compare-donors__traits option[value="${traitKey}"]`);
      const checkbox = this.querySelector(`.compare-donors__traits-mobile [name="${traitKey}"]`);

      if (option) {
        option.selected = false;
        option.closest('select').dispatchEvent(new Event('change'));
      }
      if (checkbox) {
        checkbox.checked = false;
        checkbox.dispatchEvent(new Event('change'));
      }
    }

    update() {
      this.querySelectorAll('.compare-donors__traits select').forEach(select => {
        select.querySelectorAll('option').forEach(option => {
          let active = this.querySelector(`.compare-donors__traits--active-item[data-name="${option.value}"]`);

          if (!option.selected && active) {
            active.remove();
          }

          if (option.selected && !active && !option.dataset.optionPlaceholder) {
            active = document.createElement('button');
            active.classList.add('compare-donors__traits--active-item');
            active.dataset.name = option.value;
            active.innerHTML = `
              <div class="compare-donors__traits--active-item-name">${option.text}</div>
              <div class="compare-donors__traits--active-item-remove" type="button">
                <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
                  <path d="M6 2L2 6" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M2 2L6 6" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
            `;

            active.addEventListener('click', e => {
              option.selected = false;
              option.closest('select').dispatchEvent(new Event('change'));
            });

            this.querySelector('.compare-donors__traits--active').appendChild(active);
          }
        });
      });

      const badge = this.querySelector('.compare-donors__traits--button .badge');

      if (badge) {
        const count = this.getSelectedTraits().length;
        badge.textContent = count;
        badge.style.display = count > 0 ? '' : 'none';
      }

      this.renderComparison();
    }
  });
}